import React, { useContext, useEffect, useState } from 'react';
import { Form, Input, Button, message, Spin } from 'antd';
import { LoginContext } from '../../../../context/loginContext.js';
import LocalidadesDrawer from '../../../components/localidades-drawer.js';

const CConfiguracionEmpresa = () => {
  const { user } = useContext(LoginContext);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [empresaData, setEmpresaData] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const fetchEmpresa = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${user.token}` } };
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/empresa/${user.emp_id}`,
        { headers: config.headers }
      );
      
      if (!response.ok) {
        throw new Error('Error al obtener los datos de la empresa');
      }
      
      const data = await response.json();
      setEmpresaData(data);
      
      // Si la empresa tiene una localidad, guardarla en el estado
      if (data.loc_id && data.loc_nombre) {
        setSelectedLocation({
          id: data.loc_id,
          nombre: data.loc_nombre
        });
      }
      
      form.setFieldsValue(data);
    } catch (error) {
      message.error('Error al obtener los datos de la empresa');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      // Asegurar que tenemos la información de localidad
      if (!selectedLocation) {
        message.warning('Por favor seleccione una localidad');
        return;
      }
      
      // Agregar la información de localidad a los valores
      const dataToSend = {
        ...values,
        emp_localidad: selectedLocation.id
      };
      
      const config = { 
        method: 'PUT',
        headers: { 
          'Authorization': `Bearer ${user.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      };
      
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/empresa/${user.emp_id}`, 
        config
      );
      
      if (!response.ok) {
        throw new Error('Error al actualizar la empresa');
      }
      
      message.success('Empresa actualizada correctamente');
    } catch (error) {
      message.error('Error al actualizar la empresa');
      console.error(error);
    }
  };

  // Abrir el drawer para seleccionar localidad
  const openLocationDrawer = () => {
    setDrawerVisible(true);
  };

  // Manejar la selección de localidad desde el drawer
  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
    form.setFieldsValue({ loc_nombre: location.nombre });
  };

  useEffect(() => {
    if (user?.emp_id) {
      fetchEmpresa();
    }
  }, [user]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5rem' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 600, margin: '2rem auto' }}>
      <h2 style={{ textAlign: 'center' }}>Datos de la Empresa</h2>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={empresaData}
      >
        <Form.Item
          label="Nombre"
          name="emp_nombre"
          rules={[{ required: true, message: 'Por favor ingrese el nombre de la empresa' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Dirección"
          name="emp_direccion"
          rules={[{ required: true, message: 'Por favor ingrese la dirección' }]}
        >
          <Input />
        </Form.Item>

<Form.Item
  label="Localidad"
  name="loc_nombre"
  rules={[{ required: true, message: 'Por favor seleccione una localidad' }]}
>
  <Input
    readOnly
    onClick={openLocationDrawer}
    value={selectedLocation?.nombre || ''}
    style={{ cursor: 'pointer' }}
    placeholder="Haga clic para seleccionar localidad"
  />
</Form.Item>


        <Form.Item label="Teléfono" name="emp_telefono">
          <Input />
        </Form.Item>

        <Form.Item label="Logo (URL)" name="emp_logo">
          <Input />
        </Form.Item>

        <Form.Item style={{ textAlign: 'center' }}>
          <Button type="primary" htmlType="submit">
            Guardar cambios
          </Button>
        </Form.Item>
      </Form>
      
      {/* Drawer para seleccionar localidad */}
      <LocalidadesDrawer
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        onSelectLocation={handleLocationSelect}
        initialLocationId={selectedLocation?.id}
      />
    </div>
  );
};

export default CConfiguracionEmpresa;